// Compact running-total credit pill for the Analyst session, matching
// the sketch's .credits treatment: quiet outline, muted label, the
// number in lime (dark) / primary (light).

import React from 'react';
import { Box, Tooltip } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';

import { surfacesFor } from './uiTokens';


const formatCredits = (n) => {
  const v = Number(n || 0);
  if (!v) return '0';
  if (v < 0.01) return v.toFixed(4);
  if (v < 1)    return v.toFixed(2);
  return v.toLocaleString(undefined, { maximumFractionDigits: 2 });
};


const AskDataCostBadge = ({ totalCredits, lastUsage }) => {
  const total = formatCredits(totalCredits);
  const tooltip = lastUsage
    ? `Last turn: ${formatCredits(lastUsage.cost_credits)} credits ` +
      `(in ${lastUsage.input_tokens || 0} tok, out ${lastUsage.output_tokens || 0} tok` +
      (lastUsage.tool_calls ? `, ${lastUsage.tool_calls} ${lastUsage.tool_calls === 1 ? 'query' : 'queries'}` : '') +
      `)`
    : 'No turns yet in this session';
  return (
    <Tooltip title={tooltip} arrow>
      <Box
        sx={(t) => {
          const s = surfacesFor(t);
          return {
            display: 'inline-flex', alignItems: 'center', gap: 0.8,
            px: '12px', py: '5px',
            border: `1px solid ${s.border2}`,
            borderRadius: 999,
            fontSize: 12.5,
            color: s.muted,
            cursor: 'default',
            whiteSpace: 'nowrap',
          };
        }}
      >
        <BoltIcon
          sx={(t) => ({
            fontSize: 13,
            color: t.palette.mode === 'dark'
              ? (t.brand?.lime || t.palette.primary.main)
              : t.palette.primary.main,
          })}
        />
        <Box
          component="b"
          sx={(t) => ({
            fontWeight: 600,
            color: t.palette.mode === 'dark'
              ? (t.brand?.lime || t.palette.primary.main)
              : t.palette.primary.main,
          })}
        >
          {total}
        </Box>
        {' '}spent
      </Box>
    </Tooltip>
  );
};

export default AskDataCostBadge;
